"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var FB_TRUNCATED_TEXT_LENGTH_WEB = 480;
exports.FB_TRUNCATED_TEXT_LENGTH_WEB = FB_TRUNCATED_TEXT_LENGTH_WEB;

var FB_TRUNCATED_TEXT_LENGTH_MOBILE = 120;
exports.FB_TRUNCATED_TEXT_LENGTH_MOBILE = FB_TRUNCATED_TEXT_LENGTH_MOBILE;

var FB_LARGER_FONTSIZE_LIMIT = 85;
exports.FB_LARGER_FONTSIZE_LIMIT = FB_LARGER_FONTSIZE_LIMIT;

var IG_TRUNCATED_TEXT = 90;
exports.IG_TRUNCATED_TEXT = IG_TRUNCATED_TEXT;

var FACEBOOK = {
    TRUNCATED_TEXT_LENGTH_WEB: FB_TRUNCATED_TEXT_LENGTH_WEB,
    TRUNCATED_TEXT_LENGTH_MOBILE: FB_TRUNCATED_TEXT_LENGTH_MOBILE,
    LARGER_FONTSIZE_LIMIT: FB_LARGER_FONTSIZE_LIMIT
}

var INSTAGRAM = {
    TRUNCATED_TEXT: IG_TRUNCATED_TEXT
}

exports.FACEBOOK = FACEBOOK;


